import React from "react";
import { Row, Col } from "antd";
import RatingProgressCard from "./components/RatingProgressCard";
import CustomCard from "../Card";

const ratingsData = [
  { title: "AGC - Residential", rating: 4, totalRatings: 1500 },
  { title: "AGC - Residential", rating: 3.5, totalRatings: 1200 },
  { title: "AGC - Residential", rating: 2, totalRatings: 1000 },
  { title: "AGC - Residential", rating: 1.5, totalRatings: 600 },
  { title: "AGC - Residential", rating: 1, totalRatings: 800 },
];

const RatingsCard: React.FC = () => {
  return (
    <CustomCard heading="CASE /" subHeading="RATING">
      <Row gutter={[0, 10]} style={{ maxWidth: "600px", margin: "auto" }}>
        {ratingsData.map((item, index) => (
          <Col span={24} key={index}>
            <RatingProgressCard
              key={index}
              title={item.title}
              rating={item.rating}
              totalRatings={item.totalRatings}
              showDivider={index !== ratingsData.length - 1}
            />
          </Col>
        ))}
      </Row>
    </CustomCard>
  );
};

export default RatingsCard;
